import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Post from "../components/Post";
import MediaPost from "../components/MediaPost";
import ArticlePost from "../components/ArticlePost";

import { sortByDateAsc } from "../utilities/date";
import ContentLoader from "react-content-loader";

import Radium from "radium";
import { sm, md, lg, buttonColors } from "../utilities/styles";

const SplashImageLoader = () => (
  <div style={{ width: "100%", height: "400px", backgroundColor: "#EEE" }}></div>
);

const SkeletonLoader = ({ children, loader, loaded }) => {
  if (!loaded) {
    return loader;
  } else {
    return children;
  }
};

const ctaButtonStyles = {
  width: "170px",
  padding: "0 5px",
};

const buttonStyles = {
  width: "100%",
};

sm(ctaButtonStyles, { width: "200px", padding: "0 .5em" });
md(ctaButtonStyles, { width: "220px", padding: "0 1em" });
lg(ctaButtonStyles, { padding: "0 1em" });

const humanlyIssueImagesStyles = {
  maxWidth: "33%",
  padding: "0 .5em",
};

md(humanlyIssueImagesStyles, { maxWidth: "25%", padding: "0 1em" });

const logoStyles = { width: "200px", maxWidth: "100%" };
sm(logoStyles, { width: "250px" });
md(logoStyles, { width: "300px" });

const eyeStyles = { maxWidth: "40px" };
sm(eyeStyles, { maxWidth: "50px" });
md(eyeStyles, { maxWidth: "60px" });

const ThreeButtons = (keys) => (
  <div
    className="flex justify-center"
    style={{ flexBasis: "175px", flexGrow: 0, flexShrink: 0 }}
  >
    <div style={ctaButtonStyles}>
      <h3 className="mt0">
        <a href="http://eepurl.com/did_aT" target="_blank" rel="noopener noreferrer">
          <button style={buttonStyles} key={keys[0]}>
            Join Our Newsletter
          </button>
        </a>
      </h3>
    </div>
    <div style={ctaButtonStyles}>
      <h3 className="mt0">
        <a href="http://eepurl.com/diY0E5" target="_blank" rel="noopener noreferrer">
          <button style={buttonStyles} key={keys[1]}>
            Request Humanly
          </button>
        </a>
      </h3>
    </div>
    <div style={ctaButtonStyles}>
      <h3 className="mt0">
        <Link to="/about">
          <button style={buttonStyles} key={keys[2]}>
            More About Us
          </button>
        </Link>
      </h3>
    </div>
  </div>
);

class Home extends Component {
  render() {
    const { homePageLoaded, homePage, posts } = this.props;
    const {
      splash,
      splashMobile,
      tagline,
      splash2,
      splash2Mobile,
      humanlyIssues = [],
    } = homePage;

    return (
      <div>
        <section className="header--home">
          <SkeletonLoader loader={<SplashImageLoader />} loaded={homePageLoaded}>
            <div
              className="header__picture-cropmask--splash"
              style={homePageLoaded ? {} : { display: "none" }}
            >
              <picture>
                <source media="(min-width: 92em)" srcSet={splash + "?w=1366&h=400"} />
                <source media="(min-width: 64em)" srcSet={splash + "?w=1300"} />
                <source media="(min-width: 52em)" srcSet={splash + "?w=1088"} />
                <source media="(min-width: 40em)" srcSet={splashMobile + "?w=884"} />
                <img className="header__img--splash" src={splashMobile + "?w=680"} />
              </picture>
            </div>
          </SkeletonLoader>
          <div className="header__picture_text_container--splash">
            <img src="/eye-icon.svg" style={eyeStyles} className="mb1" />
            <div>
              <img
                src="/culture-co-op-logo.svg"
                style={logoStyles}
                className="header__picture_text_container--splash-logo"
              />
            </div>
            <h1 className="header--tagline mt0">{tagline}</h1>
          </div>
          <div className="splash__seperator center">{ThreeButtons([1, 2, 3])}</div>
        </section>
        <section className="mb3">
          {splash2 && (
            <div style={{ position: "relative" }}>
              <div className="second-splash__overlay">
                <div className="mb2">
                  <a href="#articles">Our Latest Trends & News</a>
                </div>
                <div style={{ fontSize: "2em" }}>
                  <a href="#articles">▾</a>
                </div>
              </div>
              <picture>
                <source media="(min-width: 92em)" srcSet={splash2 + "?w=1366&h=400"} />
                <source media="(min-width: 64em)" srcSet={splash2 + "?w=1300"} />
                <source media="(min-width: 52em)" srcSet={splash2 + "?w=1088"} />
                <source media="(min-width: 40em)" srcSet={splash2Mobile + "?w=884"} />
                <img className="header__img--splash" src={splash2Mobile + "?w=680"} />
              </picture>
            </div>
          )}
        </section>
        <section className="py2" id="articles">
          <div className="mx-auto">
            <div className="clearfix">
              {posts
                .sort(sortByDateAsc("datePosted"))
                .slice(0, 7)
                .map((p, i) => {
                  const inner = <ArticlePost post={p} />;

                  return (
                    <Post halfColumn={p.halfColumn} key={i} featured={p.isFeatured}>
                      {inner}
                    </Post>
                  );
                })}
            </div>
            {posts.length > 0 && (
              <div className="flex justify-center">
                <div style={ctaButtonStyles}>
                  <h3>
                    <Link to="/humanly">
                      <button className="mr1" style={buttonStyles}>
                        More Humanly
                      </button>
                    </Link>
                  </h3>
                </div>
                <div style={ctaButtonStyles}>
                  <h3>
                    <Link to="/news">
                      <button className="ml1" style={buttonStyles}>
                        More News
                      </button>
                    </Link>
                  </h3>
                </div>
              </div>
            )}
          </div>
        </section>
        <section>
          <h3 className="center thin" style={{ color: "black" }}>
            Latest Issues
          </h3>
          <div className="flex justify-center mb3">
            {humanlyIssues
              .sort((a, b) => (a.issueNumber > b.issueNumber ? -1 : 1))
              .map((iss, i) => (
                <div style={humanlyIssueImagesStyles} key={i}>
                  <img src={iss.image} />
                  <div className="center bold" style={{ color: "black" }}>
                    Issue {iss.issueNumber < 10 ? "0" + iss.issueNumber : iss.issueNumber}
                  </div>
                </div>
              ))}
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    posts: state.posts,
    homePage: state.homePage,
    homePageLoaded: state.loaders.homePage,
  };
};

export default connect(mapStateToProps)(Radium(Home));



// WEBPACK FOOTER //
// ./src/pages/Home.js